export default {
  'Application': {
    'title': 'Swizi',
    'addApp': 'Add an app',
    'cancel': 'Cancel',
    'available': 'available',
    'showSubscriptionAfterLogin': "Offer users to subscribe to centers of interest",
    'MoAvailable': 'used (Maximum recommended)',
    'LOADING': 'Loading',
    'ERROR': 'An error occured. Please try agin later',
    'LOADED': ' ',
    'name': 'Name',
    'version': 'Version',
    'mapWizeApiKey': 'MapWize API key',
    'mapWizeAccessKey': 'MapWize Access key',
    'date_publication': 'Wanted publication date',
    'type_publication': 'Publication type',
    'select_type_publication': 'Select the publication type',
    'langs': 'Available languages',
    'select_langs': 'Select the available languages',
    'default_lang': 'Default language',
    'select_default_lang': 'Select the default language',
    'owner': 'Owner',
    'select_owner': 'Select the owner',
    'stores': {
      'android': 'Publish Play Store',
      'ios': 'Publish App Store',
      'error': 'A store is required',
    },
    'list': {
      'createApp': 'Create an application',
      'updateApp': 'Update the application',
    },
    'duplicate': 'Duplicate this application',
    'new_version': 'Create new version',
    'edit': 'Edit the version of the application',
    'delete': 'Delete this version of the application',
    'searchPlaceholder': 'Search...',
    'searchUserPlaceholder': 'Search a user...',
    'missingFunctionnality': 'This functionnality is not ready yet. ' +
      'It is on the road however.',
    'disableFeature': 'You do not have access to this feature',
    'copy': 'Copy from an existing application',
    'copyFromApp': 'Application to copy',
    'copyOwner': 'Owner of the application to copy',
    'select_app': 'Select the application to copy',
    'playerOnly': 'Your role is beta tester. You can only access applications of teams you are member of.',
    'NotAvailableFeature': 'This feature is not available with your current plan. ' +
      'Please contact us to get access to this feature.',
  },
  'Login': {
    'username': 'Username',
    'firstname': 'First name',
    'lastname': 'Last name',
    'email': 'Email',
    'password': 'Password',
    'confirmPassword': 'Password confirmation',
    'connect': 'Login',
    'register': 'Register',
    'forgot': 'I forgot',
    'required': 'Required',
  },
  'Header': {
    'search': 'Search...',
    'appViewer': 'Le Player',
    'ios': 'Le Player iOS',
    'android': 'Le Player Android',
    'account': 'My account',
    'team': 'Team',
    'settings': 'Settings',
    'logout': 'Logout',
    'myApps': 'My apps',
    'admin': 'Administration',
  },
  'Menu': {
    'build': 'Build',
    'distribute': 'Distribute',
    'animate': 'Animate',
    'measure': 'Measure',
    'users': 'Users',
    'usersGroups': 'Users & groups',
    'navigation': 'Style of menus',
    'library': 'Library',
    'design': 'Design',
    'contents': 'Contents',
    'dashboard': 'Dashboard',
    'datasources': 'Connectors',
    'deployment': 'Deployment',
    'api': 'API',
    'cgu': 'CGU',
    'privacyPolicy': 'Privacy policy',
    'notification': 'Notifications',
    'notificationInfo': 'Notification follow-up',
    'notificationHistory': 'Notification history',
    'news': 'News',
    'quiz': 'Quiz',
    'question': 'Question to speaker',
    'analytics': 'Analytics',
    'segmentation': 'Segmentation',
    'behaviour': 'Behavioural data',
    'entries': 'Entries',
    'userEntries': 'User entries',
    'pages': 'Popups',
    'page': 'Popups',
    'addentries': 'Add a section',
    'adduserEntries': 'Add an user section',
    'addpage': 'Add a popup',
    'version': 'Version',
    'sectionIsHomePublic': 'This section is the homepage',
    'sectionIsHomePrivate': 'This section is the homepage for connected users who are in this/those group(s): ',
    'sectionIsPrivate': 'This section is limited to the following groups:',
    'filters': 'Filters',
    'reorganize': 'Rearrange sections\' order',
  },
  'NavigationTypeMenu': {
    'title': 'Navigation type',
    'generalTitle': 'Main',
    'generalPres': 'Presentation',
    'presentation_title': 'Choose your menu style',
    'selectNavigation': 'Navigation mode',
    'configuration': 'Configuration',
    'SIDE_MENU': 'Lateral menu',
    'SIDE_MENU_ICON': 'Lateral menu (icons)',
    'SHAPE_MENU_ICON': 'Lateral menu (shape)',
    'TWO_COLS_TILES_SIDE_MENU': 'Lateral menu (tiles)',
    'TAB_BAR_NAVIGATION': 'Tabbar menu',
    'close': 'No shape',
    'fabConfiguration': 'FAB Configuration',
    'tabbarConfiguration': {
      'title': 'Configuration de la tab bar',
      'showTitle': 'Show title',
      'showSelectedIndicator': 'Show selected indicator',
      'showCentralButton': 'Show central button',
    },
  },
  'Library': {
    'title': 'Library',
    'upload': 'Upload new',
    'download': 'Download the file',
    'uploadMediasZip': 'Upload in format ZIP',
    'downloadAllMediasZip': 'Download all in format ZIP',
    'useFile': 'Use a zip file',
    'sendFile': 'Send this zip file',
    'missingFile': 'Missing file: ',
    'uploadVideo': 'Upload a video',
    'uploadPic': 'Upload a picture',
    'noDelete': 'This media is used. It can\'t be deleted.',
    'tagPlaceHolder': 'Filter by media tags',
    'noTagsFound': 'No tags found',
    'placeholderImgTags': 'Select or create a tag',
    'handleTags': 'Handle media tags',
    'selectIconCategory': 'Choose a category',
    'libraryImages': 'Image library',
    'replace': 'Replace this media',
  },
  'Error': {
    '404': 'Oops, it doesn\'t exists',
    'validEmail': 'Please use a valid email address',
    'confirmPassword': 'Passwords are not equals',
    'passwordSecurity': 'Requires : at least 8 characters long, one uppercase letter, one ' +
      'lowercase letter, a number and a special character (?+.-/!$) ',
    'required': 'Field is mandory',
    'Croutons': {
      'internalError': 'Internal error occured',
      'waiting': 'Please wait',
      'authSuccess': 'Authentication success',
      'authFail': 'Authentication failed',
      'authExpired': 'Please re-authenticate',
      'saveSuccess': 'Successful save',
      'saveError': 'Save failed, please check your data, or try again later',
      'saveErrorAction': 'You must provide actions on buttons.',
      'deleteSuccess': 'Successful delete',
      'deleteError': 'Delete failed, please check your data, or try again later',
      'uploadSuccess': 'Successful upload',
      'uploadFail': 'Upload failed, please try again later',
      'uploadConfigInvalid': 'The plugin manifest.json file is invalid',
      'saveErrorUser': 'Please check user\'s data',
      'userWSAlreadyExists': 'Login is already used',
      'groupAlreadyExists': 'Group name is already used',
      'saveErrorApiKey': 'Please check the API key\'s data',
      'saveErrorPOI': 'Please check POI\'s data',
      'saveErrorContact': 'Please check contact\'s data',
      'reinitPassword': 'An email has been sent with link to reinit your password',
      'missingHelp': 'Help is not available yet',
      'missingName': 'The name is mandatory',
      'missingType': 'The action type is mandatory',
      'duplicateName': 'The name is already used',
      'pushSuccess': 'Notification sent correctly',
      'pushError': 'Error when sending the notification',
      'changePasswordFailed': 'The password change failed : the reinitialization code has expired or is invalid.',
      'apiKeyIncorrect': 'Please check the API key\'s ',
      'subscribeDMError': 'The subscription to the Data Mediation service failed. ' +
        'Please check the service configuration.',
      'subscribeGenericError': 'The subscription to the service failed. ' +
        'Please check the service configuration.',
      'subscribeFormError': 'The subscription to the form service failed. ' +
        'Please check the form service configuration.',
      'subscribeResourceManagerError': 'The subscription to the resource service failed. ' +
        'Please check the resource service configuration.',
      'subscribePlannerError': 'The subscription to the planner service failed. ' +
        'Please check the planner service configuration.',
      'updatePlannerConfigError': 'The modification of the planner service configuration failed. ' +
        'Please check the planner service configuration.',
      'subscribeCheckinError': 'The subscription to the checkin service failed. ' +
        'Please check the checkin service configuration.',
      'updateCheckinConfigError': 'The modification of the checin service configuration failed. ' +
        'Please check the checkin service configuration.',
      'chatConfigError': 'An error about instant messaging server occured. ' +
        'Please check the instant messaging server configuration.',
      'errorLoadingData': 'Error loading data, please refresh',
      'syncSuccess': 'LThe synchronization is successful',
      'deleteUsedGroup': 'Deletion is forbidden : group is used as a parent',
    },
    'userToAddFirstname': 'Invalid firstname',
    'userToAddLastname': 'Invalid lastname',
    'userToAddEmail': 'Invalid email',
    'userToAddLogin': 'Invalid login',
    'userToAddLongEmailPhone': 'Login/email ot email/phone are mandatory',
    'userToAddPassword': 'Invalid password',
    'userToAddCPassword': 'Password and confirmation password are different',
    'beaconName': 'Invalid name',
    'beaconMacAddress': 'Invalid mac address',
  },
  'AppBar': {
    'delete': 'Delete',
    'save': 'Save',
    'undo': 'Undo',
    'edit': 'Configure',
  },
  'Welcome': {
    'item_library': 'Library',
    'item_design': 'Design',
    'item_users': 'User',
    'item_iot': 'Connectors',
    'item_content': 'Content',
    'item_navigation': 'Menu style',
    'item_library_desc': 'I manage pictures, videos and sound of my application',
    'item_design_desc': 'I choose the application\'s style by selecting an icon, a splashscreen and its colors',
    'item_users_desc': 'I manage users and groups of my application to purpose a specific user experience ' +
      'to each users',
    'item_iot_desc': 'I create Google Map POIs, beacons. I set up data, I customize views, ' +
      'I send files to users. I manage data for my app',
    'item_iot_desc2': 'I configure beacons. I add notifications, sections, popups or external links to create ' +
      'an interaction while users are near.',
    'item_content_desc': 'I build the sections of my application to manage contents, ' +
      'to animate the application by firing push notification, to give users rights',
    'item_navigation_desc': 'I choose the application\'s menu style',
  },
  'STATUS': {
    'CONSTRUCTION': 'Building',
    'PUBLICATION_IN_PROGRESS': 'Publication in progress',
    'PUBLICATION_ONLINE': 'Available on the store',
    'PACKAGING_IN_PROGRESS': 'Packaging in progress',
    'PACKAGING_DONE': 'Packaging finished',
    'ARCHIVED': 'Archived',
  },
  'STORE_STATUS': {
    'NOT_PUBLISH': 'Not published',
    'PUBLISHING': 'Publishing',
    'FAILED': 'Refused',
    'PUBLISHED': 'Available on the store',
  },
  'date': {
    'short': 'MM/DD/YY',
    'long': 'MM/DD/YYYY hh:mm a',
    'hour': 'hh:mm:ss a',
  },
  'SortType': {
    'POSITION': 'By position',
    'DATE': 'Publication date -> Creation date',
    'PUBLICATION': 'Publication date',
    'MODIFICATION': 'Modification date',
    "CREATION": "Creation date"
  },
  'ContentTypes': {
    'QUIZZ': 'Quizz',
    'PLAN': 'Interactive picture',
    'AGENDA': 'Agenda',
    'SOCIAL': 'Social network',
    'GALLERY': 'Gallery',
    'PHOTOS': 'Photos',
    'GENERICS': 'Generic',
    'GENERICS_LIST': 'Generic list',
    'NEWS': 'News',
    'DASHBOARD': 'Navigation',
    'INFOS': 'Informations',
    'MAP': 'Google Map',
    'CALLING_CARD': 'Calling card',
    'PASS_QRCODE': 'QRCode pass',
    'MULTIPLE_CHOICE': 'Multiple choice',
    'RA': 'Augmented reality',
    'GEOLOC': 'Geolocation of users',
    'CATALOG': 'Catalog',
    'RSS': 'RSS feed',
    'CHAT': 'Instant messaging',
    'RESOURCE_MANAGER': 'Resource manager',
    'ON_BOARDING': 'On Boarding',
    'FORM': 'Form manager',
    'DM': 'Data Mediation',
    'PLANNER': 'Swizi Planner',
    'PLUGIN': 'Plugin',
    'ANNUAIRE': 'Phone Book',
    'MAPWIZE': 'Mapwize',
    'BUSINESS_CARD': 'Business card',
    'PHOTO_WALL': 'photo wall',
    'SELFIE': 'Selfie',
  },
  'Content': {
    'conservePlugin': 'Conserve manifest configuration',
    'icon': 'Icon',
    'picture': 'Picture',
    'group': 'Group',
    'noCategories': 'Create and add categories to sections, so you can easily find your way between them.',
    'addAction': 'Add action',
    'actionList': 'Action list',
    'sectionBackground': 'Section background',
    'sectionHeader': 'Section header',
    'name': 'Title',
    'name0': 'Title',
    'name1': 'Category\'s name',
    'name2': 'Venue alias',
    'name3': 'Folder\'s name',
    'name5': 'Group\'s name',
    'description': 'Sub-title',
    'fontSize': 'Font size',
    'url': 'External web link',
    'navBarTitle': 'Navigation bar title',
    'entryType': 'Content type',
    'entryTags': 'Categories',
    'analyticsEntryTags': 'Analytics Tags',
    'placeholderSectionTags': 'Select or create a category',
    'TagsViewTitle': 'Sections by categories',
    'TagsViewOpen': 'Open view by categories',
    'publicAccess': 'Public access (authentication unnecessary)',
    'inMenu': 'Section is visible in the menu',
    'fullscreen': 'Section is fullscreen',
    'prefersLargeTiles': 'Large title preference',
    'searchableActive': 'Searching in list activated',
    'defaultZoom': 'Zoom by default on user',
    'sortDesc': 'List sort ascending',
    'showTrendings': 'Show trendings',
    'sortField': 'Sort criteria',
    'defaultZoomMapwize': "Default map zoom",
    'saveSuccess': 'The content has been saved',
    'saving': 'Content is saving',
    'saveError': 'Error while saving',
    'sectionContentsTitle': 'Sections',
    'addContentPlaceholder': 'Add a content',
    'addMask': 'Add a mask',
    'urlYoutube': 'Youtube web link',
    'mapWizeApiKey': 'MapWize API',
    'mapWizeVenueId': 'Venue Alias',
    'types': {
      'IMAGE': 'Picture',
      'VIDEO': 'Video',
      'HTML': 'Html',
      'URL': 'URL',
    },
    'notifyUsers': 'Notify users that the content changed',
    'programVisibility': 'Program the content\'s visibility',
    'delete': 'Delete the content',
    'add': 'Add the content',
    'save': 'Save the content',
    'cancel': 'Cancel the modifications',
    'edit': 'Edit the content',
    'notify': 'Send a notification that the content has changed right now',
    'duplicate': 'Duplicate the content',
    'configureSection': 'Configure the selection',
    'configureSectionColors': 'Configure the section colors',
    'actionName1': 'First action\'s name',
    'actionName2': 'Second action\'s name',
    'action1': 'First action\'s management',
    'action2': 'Second action\'s management',
    'editAction': 'Edit the action',
    'editAction1': 'Edit the first action',
    'editAction2': 'Edit the second action',
    'markerName': 'Name',
    'markerActive': 'Active',
    'markerUserMedia': 'Use a vidéo',
    'sendInCsv': 'Upload in Csv',
    'poiDownloadAllInCsv': 'Download yours in Csv',
    'poiDownloadCsvExample': 'Download a Csv example',
    'zipFileList': 'List of files in the zip',
    'zipFileName': 'This section has plugin',
    'noZipFile': 'This section has no plugin',
    'pluginVendor': 'Vendor: ',
    'pluginExample': 'Download manifest example',
    'pluginDemoExample': 'Download a plugin example',
    'pluginVersion': 'Version: ',
    'pluginDescription': 'Description',
    'pluginConfig': 'Configuration',
    'pluginRequirements': 'Requirements',
    'pluginApiKey': 'Api key',
    'pluginApiKeyScopes': 'Scopes : ',
    'pluginApiKeyAuth': 'Authentication : required',
    'pluginWhatsNew': "What's new on version ",
    'pluginApiKeyNoAuth': 'Authentication : not required',
    'pluginRequirementsPrivate': 'This plugin requires the application to be in mixed mode',
    'pluginRequirementsMixed': 'This plugin requires the application to be in private mode',
    'pluginSelect': 'Select a file',
    'pluginUpdate': 'Select a new file',
    'pluginUpload': 'Send a ZIP file',
    'pluginUploadFiles': 'Zip files',
    'pluginUploadManifest': 'Manifest',
    'pluginUploadInvalidManifest': 'Manifest file JSON is invalid',
    'pluginUploadErrors': 'Errors',
    'noManifestFile': "This lugin doesn't have manifest",
    'pluginManifestAdvantageTitle': 'Manifest allows you to :',
    'pluginManifestAdvantages1': 'Modifier des variables déclarées dans le manifeste, directement depuis le studio',
    'pluginManifestAdvantages2': 'Récupérer ces variables dans votre plugin grâce aux SDK swizi.js',
    'pluginManifestAdvantages3': 'Gérer les droits d\'accès au plugin et la portée de votre clé API Swizi',
    'placeholderName': 'Contact name',
    'placeholderNumber': 'Contact phone number',
    'addContact': 'Add a contact',
    'deleteContact': 'Delete acontact',
    'addGroup': 'Add a user group',
    'importAzure': 'Import from Azure AD',
    'deleteGroupe': 'Delete a group',
    'placeholderRoomName': 'Room name',
    'placeholderRoomDesc': 'Room description',
    'listChatRoom': 'Configure yours rooms',
    'chatGroup': 'Groups for this room',
    'chatTags': 'Tags for this room',
    'addChatRoom': 'Add a room',
    'deleteChatRoom': 'Delete a room',
    'errorChatRoom': 'Error when loading data',
    'contentSettings': {
      'publicationSetting': 'Publication',
      'itemColorSetting': 'Content',
      'titleColorSetting': 'Title',
      'notificationSetting': 'Notification',
    },
    'groupVisibility': 'Limit visibility to a group',
    'slideshowNotClickable': 'Slideshow not clickable',
    'selfieActive': 'Activate selfie',
    'enableConversation': 'Authorize new talk',
    'limitUserGroups': 'Show user groups only',
    'useQRCodeLocation': 'Activate QR Code location',
    'showAllFloorsList': 'Show all floors list',
    'pluginSource': 'Source code: ',
  },
  'Catalog': {
    'title': 'Catalogue',
  },
  'Alert': {
    'unsavedContent': 'Changes made not saved',
    'save': 'Save',
    'comfirm': 'Confirm',
    'cancel': 'Cancel',
    'close': 'Close',
    'confirmNotifyTitle': 'Send notification',
    'confirmNotify': 'Are you sure you want to send a notification?',
    'confirmDeleteTitle': 'Delete content',
    'confirmDeleteContent': 'Are you sure you want to delete this content?',
    'confirmChangeParticipationTitle': 'Upading application mode',
    'confirmChangeParticipationContent': 'Creating this section will put the application ' +
      'on mixed mode. Do you want to continue?',
    'confirmDeleteSection': 'Are you sure you want to delete this section?',
    'confirmDeletePage': 'Are you sure you want to delete this page?',
    'confirmDeleteAction': 'Are you sure you want to delete this action?',
    'beaconDeleteTitle': 'Delete the locating device',
    'beaconDeleteMessage': 'Are you sure you want to delete this locating device?',
    'actionDeleteTitle': 'Delete action',
    'actionDeleteMessage': 'Are you sure you want to delete this POI ',
    'poiDeleteTitle': 'Delete POI',
    'poiDeleteMessage': 'Are you sure you want to delete this POI type?',
    'poiTypeDeleteTitle': 'Delete a category',
    'poiTypeDeleteMessage': 'Are you sure you want to delete this Google MAP POI category?',
    'MapWizeTypeDeleteMessage': 'Are you sure you want to delete this Venue?',
    'KeyValueTypeDeleteMessage': 'Are you sure you want to delete this data group?',
    'APIKeyValueTypeDeleteMessage': 'Are you sure you want to delete this API data group?',
    'folderDeleteMessage': 'Are you sure you want to delete this folder?',
    'roomDeleteTitle': 'Delete room',
    'roomDeleteMessage': 'Are you sure you want to delete this room?',
    'contactDeleteTitle': 'Delete contact',
    'contactDeleteMessage': 'Are you sure you want to delete this contact?',
    'zoomTitle': 'Zoom detected',
    'zoomMessage': 'A zoom has been detected. Please display the page at 100% for convenience',
    'dupAppTitle': 'New version',
    'removeMemberTitle': 'Delete a team member',
    'removeMemberMessage': 'Are you sure you want to delete this team member?',
    'removeUserTitle': 'Delete user',
    'removeUserMessage': 'Are you sure you want to delete this user ',
    'removeUserNameMessage': 'Are you sure you want to delete user ',
    'removeGroupTitle': 'Delete group',
    'removeGroupMessage': 'Are you sure you want to delete this group?',
    'tagDeleteTitle': 'Delete tag',
    'tagDeleteMessage': 'Are you sure you want to delete this tag?',
    'deleteAppTitle': 'Delete an application version',
    'deleteAppMessage': 'Are you sure you want to delete this application version?',
    'removeProfilTitle': 'Delete profil',
    'removeProfilMessage': 'Are you sure you want to delete this profil?',
    'ldapTestTitle': 'Test de connexion',
    'azureTestMalformed': 'The JSON configuration of Azure AD is malformed',
    'authWSConfigInvalid': 'JSON autenhtication configuration is invalid',
    'smsSenderIdInvalid': 'Non accented alphanumeric characters are accepted',
    'ldapTestSuccessMessage': 'The test of the LDAP connection succeeded.',
    'ldapTestFailureMessage': 'The test of the LDAP connection failed.',
    'deloyErrorTitle': 'Deployment data',
    'deployMessage': 'Please revise deployment necessary data.',
    'notifErrorTitle': 'Notifications',
    'notifMessage': 'Are you sure you want to send this notification?',
    'deleteMediaTitle': 'Delete a library item',
    'deleteMediaMessage': 'Are you sure you want to delete this library item?',
    'sizeAlertTitle': 'File size',
    'sizeReplaceTitle': 'Replace a library item',
    'sizeAlertMessage': 'File is too big. Maximum is 2Mb.',
    'sizeReplaceMessage': 'Are you sure to replace this media ? The old one will be deleted',
    'removeApiKeyTitle': 'Delete an API key',
    'removeApiKeyMessage': 'Are you sure you want to delete this API key?',
    'removeNotifTitle': 'Delete a notification',
    'removeNotifMessage': 'Are you sure you want to delete this notification?',
    'removeFileTitle': 'Delete a file',
    'removeFileMessage': 'Are you sure you want to delete this file?',
    'removeKeyValueTitle': 'Delete a key value',
    'removeKeyValueMessage': 'Are you sure you want to delete this key value?',
    'removeAppTitle': 'Delete an application',
    'removeAppMessage': 'Are you sure you want to delete this application?',
    'addTeamAndAppTitle': 'Application access',
    'addTeamAndAppMessage': 'Are you sure you want to have access to this application?',
    'deleteAccountTitle': 'Account deletion',
    'DeleteAccountMessage': 'Are you sure you want to delete your Swizi account ?' +
      'A confirmation email will be sent to you when your account is deleted.',
    'removeFontTitle': 'Delete fonts',
    'removeFontMessage': 'Are you sure you want to delete this family of fonts?',
    'confirmPluginUploadTitle': 'Send a ZIP file',
    'confirmPluginUploadText': 'The plugin will generate an api key with the following scopes : ',
    'confirmPluginUploadText2': '. Do you want to continue? ',
  },
  'Editor': {
    'title': 'Edit a content',
    'urlPlaceholder': 'Enter a web link',
    'dropLabel': 'Click to open the library and drop a media',
    'slideshowTitle': 'Edit a slideshow',
  },
  'SectionEditor': {
    'showAllFloorsList': 'Show all floors list',
    'meetMe': 'Active "meet me" functionality',
    'mapwizeStyleURL': 'Force different style for the map',
    'showCalendar': 'Show full preview of the month ahead of the list',
    'swipable': 'Tabs are swipable (Android only)',
    'showLogin': 'Show login',
    'titleCreation': 'Create a section',
    'titleEdit': 'Configure a section',
    'titleVisibility': 'Section is only visible for groups',
    'dropLabel': 'Click to open the library and drop a media',
    'titleMapLayers': 'POIs groups to display',
    'titleMapLayersPlanner': 'POIs groups to use in thte Planner',
    'titleGeoLayers': 'User groups to display',
    'datasourcesTitle': 'Connectors',
    'geolocDevicesTitle': 'Location devices used',
    'mapWizePOISTitle': 'Mapwize Venue to display',
    'foldersTitle': 'Folders to use',
    'keyValuesTitle': 'Key/values group to use',
    'apiKeyValuesTitle': 'Key/Values group to use',
    'SectionInformations': 'Section informations',
    'SectionParams': 'Section parameters',
    'chatApiKey': 'Api Key',
    'chatSecretKey': 'Secret Key',
    'plannerTitle': 'Swizi Planners to use',
    'plannerChat': 'Chat section connected',
    'plannerMapwize': 'MapWize section connected',
    'plannerMap': 'Google Map section connected',
    'chatTitle': 'Chat server to use',
    'resourceManagerTitle': 'Resource manager to use',
    'formTitle': 'Form manager to use',
    'formTable': 'Form',
    'dmTitle': 'Data Mediation service to use',
    'Parallax': 'Parallax speed with the background image',
    'PaddingTitle': 'Padding between blocks',
    'paddingNONE': 'Aucun',
    'paddingLIGHT': 'Léger',
    'paddingBIG': 'Grand',
    'buttonPosition': 'Button position',
    'buttonPositionFLOATING': 'Floating',
    'buttonPositionFIXED': 'Fixed',
    'contentTemplate': 'Content template',
    'contentTemplateType_LIVE': 'Live',
    'contentTemplateType_GENERIC': 'Generic',
    'contentTemplateType_GENERIC_2': 'Generic 2',
    'skip': 'Skip on boarding',
    'dots': 'Show progress points',
  },
  'OnBoarding': {
    'Text_Placeholder': 'Enter custom text',
  },
  'Design': {
    'icon': 'Application icon',
    'iconNotif': 'Notification icon',
    'name': 'Application name',
    'splashscreen': 'Application splashscreen',
    'elementDesignTitle': 'Element design',
    'elementDesignSubtitle': 'Define here the element design',
    'buttonShape': 'Button shape',
    'buttonStyle': 'Button style',
    'buttonStyleTEXT': 'Text',
    'buttonStyleICON': 'Icon',
    'buttonStyleTEXT_ICON': 'Text and icon',
    'shadow': 'Shadow',
    'radius': 'Radius',
    'backButtonType': 'Back button style in the navigation bar',
    'backButtonType_CHEVRON': 'Chevron',
    'backButtonType_SQUARED_CHEVRON': 'Squared chevron',
    'showNavBarAccount': 'Show account in the navigation bar',
    'paletteSelector': 'Choix d\'une palette de couleurs',
    'selectedPalette': 'Selected palette',
    'previewPalette': 'Palette preview',
    'uiHeader': 'Colors',
    'uiTitle': 'Lorem ipsum',
    'uiText': 'Dolor si amet',
    'uiButton': 'Button',
    'advanced': 'Advanced',
    'title': 'Brand style',
    'subTitle': 'Define here your brand style',
    'logo': 'Logo on the homepage (navigation bar)',
    'iconRequirements': 'Squared icon recommanded: 1024x1024px',
    'iconNotifRequirements': 'Squared icon with alpha recommanded: 512x512px - Android only',
    'splashRequirements': 'Recommanded size: 1242x2208px',
    'logoRequirements': 'Recommanded size: 35px height max',
    'themeTitle': 'App theme',
    'themeSubtitle': 'Define here the app theme',
    'chooseTheme': 'Choose a theme',
    'font': 'Customize the application font style',
    'manageFonts': 'Manage font styles',
    'fontName': 'Font name',
    'fontRegular': 'File in TTF format for normal style',
    'fontBold': 'File in TTF format for bold style',
    'fontItalic': 'File in TTF format for italic style',
    'fontList': 'Imported customized font list',
    'fontAdd': 'Add new font',
    'needPaletteSave': 'Please save the selected palette. Then you\'ll be able to modifiy other colors',
    'colorChooserEditor': 'Choice of colors',
    'color': 'Color',
    'opacity': 'Opacity',
    'Colors': {
      'COLOR_MENU_ICON': 'Icons color',
      'COLOR_MENU_ICON_SELECTED': 'Selected item icon color',
      'COLOR_MENU_TEXT': 'Items text color',
      'COLOR_MENU_TEXT_SELECTED': 'Selected item text color',
      'COLOR_MENU_BACK_ITEM': 'Items background color',
      'COLOR_MENU_BACK_SELECTED': 'Selected item background color',
      'COLOR_MENU_BACK': 'Background color',
      'COLOR_MENU_ACCOUNT_BACK': 'Bottom item background color',
      'COLOR_NAVBAR_BACK': 'Navigation bar background',
      'COLOR_NAVBAR_ICON_TINT': 'Navigation bar color icon',
      'COLOR_NAVBAR_TEXT': 'Navigation bar color text',
      'COLOR_QL_BACK': 'Items background',
      'COLOR_QL_BACK_SELECTED': 'Selected item background',
      'COLOR_QL_ICON': 'Icons color',
      'COLOR_QL_ICON_SELECTED': 'Selected icon color',
      'COLOR_QL_TEXT': 'Item text color',
      'COLOR_QL_TEXT_SELECTED': 'Selected item text color',
      'COLOR_ITEM_TEXT_BACK': 'Items background color',
      'COLOR_ITEM_SEPARATOR': 'Items separator color',
      'COLOR_USER_COLOR_1': 'Selected item background color',
      'COLOR_USER_COLOR_3': 'Bottom item background color',
      'COLOR_ITEM_TITLE': 'Item title text color',
      'COLOR_ITEM_TITLE_SELECTED': 'Selected item title text color',
      'COLOR_GLOBAL_BACK': 'Background color',
      'COLOR_ITEM_BACK': 'Item background color',
      'COLOR_ITEM_INTRODUCTION': 'Item subtitle text color',
    },
    'generatePaletteFromFile': 'Generate a palette from a photo',
  },
  'User': {
    'all': 'All',
    'id': 'ID',
    'Lastname': 'Last name',
    'Firstname': 'First name',
    'Login': 'Login',
    'Email': 'email',
    'lastLogin': 'Last login',
    'nbApps': 'Number of applications',
    'Twitter': 'Twitter account',
    'Group': 'Group(s)',
    'SpecificGroup': 'Specific group(s)',
    'Status': 'Status',
    'Phone': 'Phone number',
    'MobilePhone': 'Mobile phone',
    'Password': 'Password',
    'newPassword': 'New password',
    'CPassword': 'Confirm password',
    'changePassword': 'Change password',
    'deleteAccount': 'Request deletion of my account',
    'configRights': 'Configuration rights',
    'contentRights': 'Content rights',
    'USER_RIGHTS': {
      'DATA_LOCALISATION_DEVICE': 'Localisation devices',
      'DATA_LOCALISATION_BEACON': 'beacon localisation',
      'DATA_LOCALISATION_STIMSHOP': 'stimshop localisation',
      'DATA_POI': 'Points of interests',
      'DATA_MAPWIZE': 'Mapwize',
      'DATA_FILE': 'Files',
      'DATA_KEY_VALUE': 'clés valeurs',
      'DATA_PLANNING': 'Planning',
      'DATA_CHECKIN': 'Checkin',
      'DATA_CHAT': 'Instant messaging',
      'DATA_RESOURCE_MANAGER': 'Resource manager',
      'DATA_FORM': 'Form manager',
      'DATA_GENERIC': 'Generic connector',
      'DATA_DM': 'Data mediation',
      'PLUGIN': 'Plugin',
      'PLANNER': 'Planning',
      'CHAT': 'Chat',
      'MAPWIZE': 'Mapwize',
      'STIMSHOP': 'Stimshop',
      'FILE': 'Files',
      'KEY_VALUE': 'Keys avlues',
      'RESOURCE_MANAGER': 'Resources',
      'FORM': 'Forms',
      'DM': 'Data mediation',
    },
    'UsersTitle': 'Users list',
    'FormLastNameValidation': '60 characteres max, letters only',
    'FormFirstNameValidation': '60 characteres max, letters only',
    'FormEMailValidation': '60 characteres max, letters, numbers and @ authorized',
    'FormPasswordValidation': '64 characteres max, at least 1 letter, 1 number and 1 special charactere',
    'FormPhoneValidation': '20 characteres max, numbers only',
    'importUsers': 'Import users',
    'importSend': 'Select and upload',
    'importExample': 'Download an example',
    'addGroup': 'Add a group',
    'addUser': 'Add a user',
    'editGroup': 'Edit a group',
    'editUser': 'Edit a user',
    'active': 'Active',
    'inactive': 'Inactive',
    'ActiveAccount': 'Active account',
    'Team': {
      'profile': 'Profile',
      'noMember': 'No member in the team',
      'addMember': 'Add a team member',
      'deleteMember': 'Delete this member from team',
    },
    'Configuration': 'Configuration',
    'ModeParticipation': 'Type of access',
    'Auths': 'Authentication types',
    'showInfo': 'Profile information to display',
    'AccessTwitter': 'Sign-in with Twitter',
    'Participation': {
      'MIXED': 'Mixed',
      'PUBLIC': 'Public',
      'PRIVATE': 'Private',
      'GAMO': 'Swizi',
      'Facebook': 'Facebook',
      'Twitter': 'Twitter',
      'LDAP': 'LDAP directory',
      'WS': 'Web service',
      'AZURE_AD': 'Azure AD',
    },
    'loginType': 'Login type',
    'loginTypes': {
      'FULLSCREEN_CLASSIQUE': 'Classical full screen',
      'POPUP': 'Popup',
      'ENROLL_SMS': 'SMS enrollment',
    },
    'smsSender': 'SMS sender',
    'profileTemplate': 'Profile type',
    'profileTemplates': {
      'CLASSIC': 'Basic profile',
      'DYNAMIC': 'Advenced profile (with choice of displayed content)',
    },
    'profileInfo': {
      'login': 'Login',
      'email': 'Email',
      'firstname': 'First name',
      'lastname': 'Last name',
      'company': 'Company',
      'function': 'Function',
      'phone': 'Phone',
      'mobilePhone': 'Mobile phone',
      'age': 'Age',
      'addrLine1': 'Address 1',
      'addrLine2': 'Address 2',
      'zipCode': 'Zip code',
      'city': 'City',
      'country': 'Country',
    },
    'importLdapGroups': 'Get the groups from the LDAP directory',
    'importLdapUsers': 'Get the users from the LDAP directory',
    'azureConfig': 'Configuration of Azure AD',
    'azureConfigClientId': 'ID client',
    'azureConfigSecret': 'Secret',
    'azureConfigTenant': 'Tenant',
    'azureConfigCheckSynchro': 'Check the AD synchronization configuration',
    'ldapTest': 'Test the connexion to the LDAP directory',
    'wsConfig': 'Authentication web service configuration',
    'loginTimeout': 'Expiration du login (minutes)',
    'tokenTimeout': 'Expiration du jeton (minutes)',
    'forgottenPwd': 'Forgotten password activated',
    'updatePhoto': 'Photo modification activated',
    'blockAccountCreation': 'Block account creation',
    'useBiometric': 'Activate biometric authentication',
    'activateAccount': 'Show account activation',
    'accountCreationGroups': 'Default groups for user creation',
    'errors': {
      'alreadyUsed': 'The email is already used',
    },
  },
  'Group': {
    'Label': 'Name',
    'Description': 'Description',
    'Type': 'Type',
    'Type_SPACE': 'Space',
    'Type_GROUP': 'Group',
    'Type_AZURE_AD': 'Azure AD',
    'Geoloc': 'Geolocalisable',
    'GeolocInterval': 'Geolocalisation interval',
    'Subscription': 'Point of interest (subscription)',
    'SubscriptionInformation': 'Point of interest name',
    'DefaultSpace': 'Default space',
    'GroupsTitle': 'Groups list',
    'FormLabelValidation': '60 characteres max, letters, numbers and special characteres authorized',
    'FormDescriptionValidation': '255 characteres max, letters, numbers and special characteres authorized',
  },
  'Icons': {
    'publication': 'Publication',
    'access_evenement': 'Event access',
    'participants': 'Participants',
    'realite_augmentee': 'Augmented reality',
    'business_commerce_banque': 'Business / Market / Bank',
    'objectifs_commerciaux_bilans_analytics': 'Commercial target / Bilans / Analytics',
    'business_commerce_banque2': 'Business / Market / Bank 2',
    'intervenants': 'Intervenants',
    'application_evenement': 'Application / Events',
    'culture_musique_theatre': 'Culture / Music / Theater',
    'galerie_photos_videos': 'Gallery / Photos / Videos',
    'plan_interactif': 'Interactive picture',
    'infos_pratiques': 'Practical infos',
    'accueil': 'Home',
    'activites_sportives': 'Sport',
    'social_wall': 'Social Wall',
    'autres_activites': 'Other activities',
    'meteo': 'Weather',
    'hebergement': 'Lodging',
    'quizz': 'Quizz',
    'activites_sportives2': 'Sport 2',
    'sponsor_solidarite_partenaire': 'Sponsor / Solidarity / Partenership',
    'a_propos': 'About',
    'selfie': 'Selfie',
    'agenda': 'Calendar',
  },
  'sections': {
    'filterPlaceholder': 'By group',
    'filterPlaceholders': 'Groups',
    'filterPlaceholderType': 'By content type',
    'params': 'View customization',
    'paramsSettings': 'Content settings',
    'paramsSettingsKey': 'Key',
    'paramsSettingsValue': 'Value',
    'dashboard': {
      'title': 'Screen template',
      'dnd': 'Drag and drop a section',
      'slideshowParam': 'Clic to set up the slideshow',
      'HEADER_SLIDESHOW': 'Header and slideshow',
      'HEADER_SLIDESHOW_TILES': 'Header, slideshow and tiles',
      'SLIDE_SHOW_FULLSCREEN': 'Fullscreen slideshow',
      'HONEYCOMB': 'Fullscreen slideshow, hexagonal tiles',
      'TAB_CONTAINER': 'Multi-views container',
      'labelHeaderHC': 'Catch phrase',
      'GENERIC_LIST': 'List',
      'LIVE': 'Live',
      'LIVE 2': 'Live 2',
      'RSS_CLASSIC': 'Classic list',
      'RSS_CARDS': 'Tiles',
      'CARDS': 'Cards',
      'MATERIAL_CARDS': 'Material cards',
      'LEFT_RIGHT_CARDS': 'Left/right cards',
      'PEOPLE': 'People',
      'ACTION_LIST': 'Action list',
    },
    'plan': {
      'planParam': 'Clic to set up a new interactive picture',
      'namePlaceholder': 'Name the picture',
      'areas': 'Interactives areas',
      'drop': 'Background image',
      'edit': 'Edit the interactive picture',
      'delete': 'Delete interactive picture',
      'addBackImage': 'Add the background image',
      'deleteBackImage': 'Delete the background image',
      'zones': {
        'add': 'Add an area',
        'edit': 'Edit the area',
        'delete': 'Delete the area',
      },
    },
    'map': {
      'poi': {
        'add': 'Add a POI',
        'edit': 'Edit the POI',
        'delete': 'Delete the POI',
        'choose': 'Place the POI',
        'addAction': 'Add an action',
        'editAction': 'Modify an action',
        'genericAction': 'More action',
        'search': 'Search a place',
        'noPoi': 'There is no configured POI. Please add at least one in the Connectors section.',
        'selectType': 'Select a POI type',
        'mapwizeVenue': 'Venue',
        'mapwizePlace': 'Place',
        'groups': 'Groups',
      },
    },
    'mapwize': {
      'errorApp': 'Error while initializing Mapwize. Please check the application ' +
        'Mapwize configuration.',
      'errorSection': 'Error while initializing Mapwize. Please check the section ' +
        'Mapwize configuration.',
    },
    'colors': {
      'TAB_BAR_BACKGROUND': 'Tabbar background color',
      'TAB_BAR_SELECTED_TAB': 'Selected tab color',
    },
    'dimensions': 'Dimension',
    'dimensionsXSmall': 'Very small',
    'dimensionsSmall': 'Small',
    'dimensionsMedium': 'Medium',
    'dimensionsLarge': 'Large',
    'backgroundImage': 'Tile background image',
    'sectionTarget': 'Section',
    'actionTarget': 'User interaction',
    'titleTarget': 'Title',
    'icon': 'Icon',
    'color': 'Color',
    'sectionNotClickable': 'Section not clickable',
    'hideTitle': 'Hide title',
    'template': 'Template',
    'templateType_DEFAULT': 'Default',
    'templateType_TITLE': 'Title',
    'templateType_TITLE_NOTIFICATION': 'Title with notification center',
    'templateType_LIST_PREVIEW': 'list preview',
    'templateType_CARD_PREVIEW': 'Card preview',
    'templateType_TAGGED_ITEM_WITH_ROW': 'Head  content with row',
    'templateType_TAGGED_ITEM_WITH_COLUMN': 'Head content with column',
    'templateType_TAGGED_CARD_ITEM_WITH_ROW': 'Cards with head content and row',
    'arrowType': 'Arrow type',
    'imageRatio': 'Image ratio',
    'imageRatio_DEFAULT': 'Squarred',
    'imageRatio_LANDSCAPE': 'Landscape',
    'imageRatio_PORTRAIT': 'Portrait',
    'arrowType_DEFAULT': 'Default',
    '$firstname': 'User firstname',
    '$lastname': 'User lastname',

    'arrowType_SQUARED_CHEVRON': 'Squared chevron',
    'actionLayout': 'Action layout',
    'actionLayout_VERTICAL': 'Vertical',
    'actionLayout_HORIZONTAL': 'Horizontal',
    'numberOfItems': 'Number of items',
    'actionShowDots': 'Show action dots',
    'showNotificationCenter': 'Show notification center'

  },
  'select': {
    'placeholder': 'Select a group',
    'placeholderProfile': 'Select a profile',
    'placeholderIcon': 'Search an icon',
    'placeholderSectionTags': 'Filter by categories',
    'placeholderSectionName': 'Filter by sections',
    'placeholderImage': 'Search a picture',
    'noResult': 'No result found',
  },
  'GenericAction': {
    'description': 'Select an action',
    'name': 'Name',
    'i18nTitle': 'Title',
    'action': 'Action',
    'nothing': '--',
    'url_external': 'external URL',
    'type_section': 'Show a section',
    'type_popup': 'Open a opup',
    'type_plan': 'Show an interactive picture',
    'type_login': 'Open the login screen',
    'type_logout': 'Log out',
    'type_create_account': 'Open the account creation screen',
    'type_resetPassword': 'Open the password reset screen',
    'type_changePassword': 'Open the password modification screen',
    'type_subscription': 'Open the subscription screen',
    'title': 'Edit an action',
    'params': 'URI parameters',
    'type_sync_section': 'Synchronize section',
    'type_sync_refresh_token': 'Refresh token',
    'type_sync_clean_cache': 'Empty cache',
  },
  'Crop': {
    'PleaseCropIcon': 'Please crop the image in a squared way',
    'PleaseCropSplash': 'Please crop the image in a 16/9 in portrait mode',
    'Validate': 'Validate',
  },
  'IOTMenu': {
    'beaconParametre': 'Locating device',
    'title': 'Connectors',
    'beaconTitle': 'Location device',
    'beaconListe': 'List',
    'beaconAction': 'Actions',
    'beaconPlan': 'Plan',
    'poiTitle': 'Points of interest',
    'poiAddGroup': 'Add a category',
    'poiEditGroup': 'Edit a category',
    'mapWizeTitle': 'MapWizeAPI',
    'resourcesTitle': 'Files',
    'keyValueTitle': 'Key/Value data',
    'apiTitle': 'API source data',
    'mapWizeAddVenu': 'Add a venue',
    'resourceAdd': 'Add a folder',
    'keyValueAdd': 'Add data group',
    'apiKeyValueAdd': 'Add API data group',
    'mapwizeEditVenue': 'Edit a Venue',
    'mapwizeAddVenue': 'Add a Venue',
    'filesEditFolder': 'Edit a folder',
    'filesAddFolder': 'Add a folder',
    'keyvalueEditCategory': 'Edit a category',
    'keyvalueAddCategory': 'Add a category',
    'apikeyvalueEditCategory': 'Edit a category',
    'apikeyvalueAddCategory': 'Add a category',
    'plannerTitle': 'Planning',
    'plannerAdd': 'Add a planning service',
    'checkinTitle': 'Checkin',
    'checkinAdd': 'Add a checkin service',
    'chatTitle': 'Instant messenger',
    'chatAdd': 'Add a instant messenger service',
    'resourceManagerTitle': 'Resource manager',
    'resourceManagerAdd': 'Add a resource manager',
    'formTitle': 'Form manager',
    'formAdd': 'Add a form manager',
    'dmTitle': 'Data mediation service',
    'dmAdd': 'Add a data mediation service',
    'genericTitle': 'Generic connector',
    'genericAdd': 'Add ageneric connector',
  },
  'Beacon': {
    'activationGlobal': 'Activate beacon function',
    'layoutBeacon': 'Layout for yours beacons',
    'layoutSelectHint': 'Select your locating device',
    'titleEditorEdit': 'Edit your locating device',
    'titleEditorCreate': 'Add your locating device',
    'colActive': 'Is active',
    'colName': 'Name',
    'colUUID': 'Mac address (XX:XX:XX:XX:XX:XX)',
    'OtherID': 'UUID & Majorr - Minor',
    'colStrength': 'Signal Force',
    'colPower': 'Power',
    'colLastSeen': 'Last seen',
    'delete': 'Delete the locating device',
    'edit': 'Edit the locating device',
    'Major': 'Major',
    'Minor': 'Minor',
    'macAddress': 'Mac Address',
    'audioSignal': 'Audio Signal',
    'placeholderAudio': 'Select a signal',
    'downloadAudio': 'Download the audio file',
    'Action': {
      'delete': 'Delete this action',
      'edit': 'Modify this action',
      'listTitle': 'List of actions',
      'concernedBeacon': 'Concerned beacon',
      'listOfGroups': 'Concerned groups',
      'detectionType': 'Action',
      'addAction': 'Add action',
      'genericAction': 'Action',
      'actionNumber': 'Action #{index}',
      'name': 'Action name',
      'groups': 'Action\'s groups',
      'start': 'Start hour of detection',
      'end': 'End hour of detection',
      'detectionDate': 'Detection day',
      'detection': 'Detection type',
      'detectionTypes': {
        'PROXIMITY': 'Proximity',
        'ENTER_ZONE': 'Enter area',
        'EXIT_ZONE': 'Leave area',
      },
      'frequency': 'Frequency',
      'frequencyTypes': {
        'ONCE': 'Once',
        'EVERY_MIN': 'Every minutes',
        'EVERY_15_MIN': 'Every 15 minutes',
        'EVERY_30_MIN': 'Every 30 minutes',
        'EVERY_HOUR': 'Every hours',
        'EVERY_6_HOURS': 'Every 6 hours',
        'EVERY_DAY': 'Every days',
      },
      'nbMax': 'Max number of dectections',
    },
    'noBeacon': 'There is no beacon configured. Please add at least one in the and when a user will' +
      ' detect a beacon, it\'s position will displayed on the map.',
    'mapBeaconToMapWize': 'Connect a location device',
    'mapGMapsToMapWize': 'Connect a Google Maps POI',
    'showAllMapWizePlaces': 'Show all POIs',
    'maskAllMapWizePlaces': 'Hide all',
    'display': 'Display',
  },
  'Tour': {
    'prevBtn': 'Previous',
    'nextBtn': 'Next',
    'doneBtn': 'Done',
    'skipBtn': 'Skip',
    'closeBtn': 'Close',
  },
  'CGU': {
    'writeCGU': 'Write terms of use :',
  },
  'PrivacyPolicy': {
    'writePolicy': 'Write privacy policy :',
  },
  'Deploy': {
    'apiKey': 'API key',
    'appID': 'App ID',
    'certif': {
      'current': 'Current : ',
      'file': 'Certificate file of iOS push',
      'password': 'Certificate password of iOS push',
      'keystore': 'Keystore Android',
      'manageKeystore': 'Manage keystore',
      'genKeystore': 'Generate a keystore',
      'launchGen': 'Generate new',
    },
    'steps': {
      'building': 'Building',
      'generate': 'Generate',
      'storeDeposit': 'Deposite on Stores',
      'waitingApproval': 'Waiting approval',
      'available': 'Available',
    },
    'specific': 'Mandatory informations',
    'iosSpecific': 'iOS informations',
    'androidSpecific': 'Android informations',
    'accountEmailIOS': 'Apple Developer account email',
    'accountPasswordIOS': 'Apple Developer account password',
    'accountEmailAndroid': 'Google Developer account email',
    'accountPasswordAndroid': 'Google Developer account password',
    'keystorePasswordAndroid': 'Keystore password',
    'keyAliasAndroid': 'Key alias',
    'keyPasswordAndroid': 'Key password',
    'hashAndroid': 'Hash',
    'googleJSON': 'Google JSON',
    'androidGCMID': 'Push notifications GCM ID',
    'version': 'Version',
    'common': 'Common informations',
    'BundleID': {
      'iOS': 'iOS Package name',
      'android': 'Android Package name',
    },
    'KeyWords': 'Keywords to find your app (coma separated)',
    'PrivacyPolicyModel': 'Use the Swizi privacy policy model',
    'PrivacyPolicyURL': 'Privacy policy URL',
    'WritePrivacyPolicy': 'Or insert it here',
    'ContactEmail': 'Contact email',
    'DemoAccount': 'Demo account',
    'DemoAccountPassword': 'Demo account password',
    'askDeploy': 'Deploy',
    'store': {
      'public': 'App Store & Google Play Store',
      'publicAndroid': 'Google Play Store',
      'publicIOS': 'App Store',
      'private': 'Private store KStore',
      'manual': 'Manual',
      'publicInfo': 'The application will be available throught the Stores. ' +
        'Please consider few days to be able to download the app.',
      'privateInfo': 'The application will be available for KStore users. ' +
        'Please consider less than a day to be able to download the app.',
      'manualInfo': 'You have to do the deployment process to let users access your app. ' +
        'For iOS, please contact us to choose the packaging type (in house / AppStore).',
    },
    'errors': {
      'package': {
        'ios': 'This package name is already used on the App Store',
        'android': 'This package name is already used on the Play Store',
      },
    },
    'iOSDisclaimer': 'We only ask, for iOS, your developer account. ' +
      'Or a dedicated AppleID for Swizi. ' +
      'We don\'t ask more information because it will be easier for us to ' +
      'create the required certificates and provisionning profiles to generate the app.',
  },
  'Api': {
    'manageKeys': 'API key management',
    'addApiKey': 'Add an API key',
    'nameKey': 'Label',
    'valueKey': 'Value',
    'dateKey': 'Generation date',
    'activeKey': 'Active',
    'authKey': 'Secured',
    'authorizations': 'Authorizations',
    'editKey': 'Edit a key',
    'addKey': 'Add a key',
    'active': 'Yes',
    'inactive': 'No',
  },
  'NotifMenu': {
    'title': 'Notifications',
    'notificationCenter': 'Notification center',
    'send': 'Send notifications',
    'followUp': 'Scheduled notifications',
    'history': 'History of notifications',
  },
  'NotifInfo': {
    'followUpManagement': 'Scheduled notifications',
    'history': 'History of notifications',
    'type': 'Type',
    'typeCONTENT': 'Content',
    'typeFILTER': 'Targeted',
    'title': 'Title',
    'message': 'Message',
    'notifDate': 'Notification date',
    'nbDevices': 'Number og devices',
    'action': 'Action',
  },
  'Notif': {
    'sendBtTitle': 'Send notifications',
    'sendBtLabel': 'Send',
    'technical': 'Technical notification',
    'title': 'Title',
    'titlePlaceHolder': 'Title of notification',
    'message': 'Message',
    'messagePlaceHolder': 'Message for yours users',
    'action': 'Generic action',
    'actionPlaceHolder': 'Define an action',
    'actionUpdate': 'Update the action',
    'diffusionMode': 'Diffusion mode :',
    'everyone': 'Everybody',
    'filter': 'Targeting',
    'panelGroup': 'Groupes',
    'panelGeoloc': 'Geolocalisation',
    'clearGeoloc': 'Clear the selection',
    'panelDevices': 'Devices',
    'panelProperties': 'Users properties',
    'filterByGroup': 'Filter by groups',
    'filterByUsers': 'Filtrer par users',
    'inputIdentifier': 'Enter an identifier ...',
    'createUserOption': 'Add user ID "',
    'filterByDeviceOS': 'Filter by Operating System',
    'filterByDeviceLang': 'Filter by language',
    'errorMessageEmpty': 'Error : The message can\'t be empty',
    'errorTitleEmpty': 'Error : The title can\'t be empty',
    'date': 'Date',
  },
  'Admin': {
    'users': 'Users',
    'profiles': 'Profiles',
    'applications': 'Applications',
    'icons': 'Icons',
    'images': 'Pictures',
  },
  'AdminProfiles': {
    'title': 'Profiles',
    'add': 'Add a profil',
    'edit': 'Edit a profil',
    'name': 'Name',
    'desc': 'Description',
    'level': 'Level',
    'properties': 'Authorisations',
    'freemium': 'Freemium offer',
    'Error': {
      'name': 'Error in the name',
      'desc': 'Error in the description',
      'level': 'Error in the level',
      'add': 'Error when saving profil',
    },
  },
  'AdminApplications': {
    'title': 'Applications',
    'id': 'Id',
    'name': 'Name',
    'owner': 'Owner',
    'version': 'Version',
    'versionCode': 'Version Code',
    'apiKey': 'API key',
    'creation': 'Creation',
    'status': 'Statut',
    'edit': 'Edit the application',
    'deactivatePwd': 'Deactivate the password checking',
  },
  'Analytics': {
    'title': 'Analytics',
    'countly': {
      'instructions': 'To access the statistics of your application : ',
      'instructions2': 'Click on ',
      'instructions3': 'Countly external link.',
      'instructions4': 'If it\'s your first authentication, click on "forgotten password" and use your Swizi account ' +
        'email.',
      'instructions5': 'Once you are logged in, click on "Statistics" menu and select the application ',
    },
    'today': 'Today',
    '7days': '7 days',
    '30days': '30 days',
    '60days': '2 months',
    '90days': '3 months',
    'year': '1 year',
    'totalSessions': 'Total number of sessions',
    'totalUsers': 'Total number of users',
    'newUsers': 'New users count',
    'totalTime': 'Total time usage',
    'avgTime': 'Average time usage',
    'topPlatform': 'Top OS',
    'topResolutions': 'Top resolution',
    'topCarriers': 'Top carriers',
    'topUsers': 'Top arrival of new users',
    'noStatDatas': 'There is no data available right now.',
    'useAnEvent': 'Please select an event to display statistics',
    'events': {
      'SCR_SPLASHSCREEN': 'Splashscreen',
      'SCR_WELCOME': 'Home',
      'SCR_INTERSTICIAL': 'Interserticial',
      'SCR_LEGAL_MENTION': 'Legal',
      'EV_CLICK_INTERSTICIEL': 'Interserticial - Click',
      'EV_CLICK_SHARE_APP': 'App - Share',
      'EV_SKIP_AUTHENTIFICATION': 'Login - Skip',
      'SCR_AUTHENTIFICATION': 'Login',
      'SCR_SIGNUP': 'Signup',
      'SCR_LOST_PASSWORD': 'Forgot password',
      'EV_AUTH_BAD_LOGIN': 'Login - Connection error',
      'EV_AUTH_BAD_SIGNUP': 'Login - Signup error',
      'EV_AUTH_OK': 'Login - Connection OK',
      'EV_AUTH_FB_OK': 'Login - Connection FaceBook OK',
      'EV_AUTH_TWITTER_OK': 'Login - Connection Twitter OK',
      'EV_SIGNUP_OK': 'Login - Signup OK',
      'SCR_DASHBOARD': 'Presentation',
      'EV_QL_CLIC': 'Presentation - Click Item',
      'EV_SLIDESHOW_CLIC': 'Presentation - Click Slideshow',
      'EV_SLIDESHOW_SHARE': 'Presentation - Click Share slideshow',
      'SCR_QUIZZ_LIST': 'Quizz list',
      'SCR_QUIZZ': 'Quizz',
      'EV_QUIZZ_SEND_ANSWER': 'Quizz - Send answer',
      'SCR_PLAN': 'Interactive picture',
      'EV_PLAN_CLIC_ZONE': 'Interactive picture - Click area',
      'SCR_AGENDA': 'Agenda',
      'SCR_AGENDA_SESSION': 'Agenda - Session',
      'EV_AGENDA_FAVORIS': 'Agenda - Favorite',
      'EV_AGENDA_ADD_CALENDAR': 'Agenda - Add calendar',
      'EV_AGENDA_SEND_QUESTION': 'Agenda - Send question',
      'SCR_SOCIAL': 'Social',
      'EV_SOCIAL_WRITE_TWEET': 'Social - Tweet',
      'SCR_GALLERY_LIST': 'Gallery list',
      'SCR_GALLERY_DETAIL': 'Gallery detail',
      'EV_GALLERY_SHARE': 'Gallery - Share',
      'SCR_GENERIC_LIST': 'Generic list',
      'SCR_GENERIC_DETAIL': 'Generic detail',
      'SCR_GENERIC_WEB': 'Web detail',
      'EV_BEACON': 'Beacon - Detection',
      'EV_SHOW_MENU_PERSO': 'Menu - Menu perso',
      'EV_MENU_DISCONNECT': 'Menu - Logout',
      'EV_MENU_CONNECT': 'Menu - Login',
      'SCR_MY_ACCOUNT': 'My account',
      'SCR_CARTE_VISITE': 'My Calling Card',
      'SCR_MY_PASS': 'My Pass',
      'SCR_SELFIE': 'Selfie',
      'EV_SELFIE_TAKE': 'Selfie - Take photo',
      'EV_SELFIE_SHARE': 'Selfie - Share',
      'EV_SELFIE_DELETE': 'Selfie - Delete',
      'EV_NOTIF_SHOW': 'Notification - Display',
      'EV_NOTIF_CLIC': 'Notification - Click',
      'EV_LAUNCH_ROUTE': 'Map - Route',
      'EV_PARAM_BLE_DISABLE': 'Settings - BLE OFF',
      'EV_PARAM_BLE_ENABLE': 'Settings - BLE ON',
      'EV_PARAM_NOTIF_DISABLE': 'Settings - Push OFF',
      'EV_PARAM_NOTIF_ENABLE': 'Settings - Push ON',
      'EV_LANG': 'Lang',
    },
  },
  'rights': {
    'title': 'Here are the different profiles and permissions available for users. ' +
      'You can view this information at any time by displaying help.',
    'updateNavigation': 'Update navigation',
    'updateApp': 'update an app',
    'selectVersionApp': 'Select an app version',
    'manageUsers': 'Manage users',
    'designerExpert': 'Designer expert',
    'deployment': 'Deploy',
    'deleteApp': 'Delete an app',
    'createVersionApp': 'Create an app version',
    'createSection': 'Create a section',
    'createCopyApp': 'Create an app copu',
    'createApp': 'Create an app',
    'admin': 'Administration',
    'updateSection': 'Update sections',
    'manageApiKeys': 'Manage API Keys',
    'manageFreemium': 'Manage Fremium accounts',
    'canNotify': 'Notifications',
    'playerOnly': 'Player access only',
  },
  'Datasource': {
    'key': 'Key',
    'value': 'Value',
    'valueEnter': 'Use the Enter key to add the tag',
    'addKeyValue': 'Add a key/value',
    'scope': 'Scope',
    'param': 'Type',
    'addFile': 'Add a file',
    'name': 'Name',
    'size': 'Size',
    'date': 'Creation date',
    'kb': 'Kb',
    'mb': 'Mb',
    'OTHER': 'CUSTOM',
    'BADGE': 'BADGE',
    'VISIBILITY': 'VISIBILITY',
    'COLOR_NAVBAR': 'Navbar color',
    'nonEditableValue': 'The USER scope gives one value per user',
    'minutesUnit': 'minute(s)',
    'urlMS': 'Service URL',
    'apiKey': 'API key',
    'secretKey': 'secret key',
    'type': 'Type',
    'subscribePath': 'Subscription URI',
    'updatePath': 'Modification URI',
    'plannerId': 'Planner identifier',
    'plannerName': 'Planner name',
    'plannerType': 'Planner type',
    'plannerVersion': 'Planner version',
    'category': 'Category',
    'userId': 'User identifier',
    'groupId': 'Group',
    'poiId': 'POI identifier',
    'delayBeforeCheckin': 'Delay before checkin',
    'duration': 'Duration',
    'resourceName': 'Name',
    'synchroFrequence': 'Synchronization frequence',
    'chatName': 'Nom du chat',
    'tags': 'Tags',
    'createOption': 'Create option "',
    'createChatConnectorOption': 'Create a new messenger connector "',
    'createFormConnectorOption': 'Create a new form connector "',
    'searchConnector': 'Search or create new connector ...',
    'sync': 'Synchronize the mobile phones',
  },
}
